import { CITY_AUTO_SUGGESTION } from 'actions/TravelActions/cityAutoSuggestionActions';
import { LOADING, SUCCESS, ERROR } from 'utils/asyncStatusHelper';
export default function cityAutoSuggestion(state = {}, action = { type: null, id: '' }) {
    switch (action.type) {
        case CITY_AUTO_SUGGESTION.REQUEST:
            return Object.assign(Object.assign({}, state), { [action.id]: Object.assign(Object.assign({}, (state && state[action.id])), { asyncStatus: LOADING }) });
        case CITY_AUTO_SUGGESTION.SUCCESS:
            return Object.assign(Object.assign({}, state), { [action.id]: Object.assign(Object.assign(Object.assign({}, (state && state[action.id])), { asyncStatus: SUCCESS }), action.data) });
        case CITY_AUTO_SUGGESTION.ERROR:
            return Object.assign({}, state, {
                [action.id]: {
                    asyncStatus: ERROR,
                    error: action.error
                }
            });
        default:
            return state;
    }
}
